
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoi as ObcPoiElement} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi/poi.js';
 
 
 

 
 export const ObcPoi = createComponent({
   react: React,
   tagName: 'obc-poi',
   elementClass: ObcPoiElement,
   events: {
     
   }
  });
 
 